// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[toggle-fields-enabled]', (element) => {
  function toggleInputDisabled() {
    const inputSelector = element.getAttribute('toggle-fields-enabled')
    const inputs = element.closest('form').querySelectorAll(`${inputSelector} input, ${inputSelector} select`)

    inputs.forEach((input) => {
      input.disabled = element.checked
    })
  }

  element.addEventListener('change', (e) => {
    toggleInputDisabled()
  })

  toggleInputDisabled()
})
